import React from 'react'
import { Feature } from '../../components'
import './features.css'

const featuresData = [
  {
    title: 'Logistics',
    text: 'Make your transportation business truly modern and digitized to win more clients, boost profits, and stand out against your competitors.',
  },

  {
    title: 'Healthcare',
    text: 'You will always be in the right position to effectively, safely, and seamlessly process sensitive medical data, provide high-quality medical services, and drive greater revenues.',
  },

  {
    title: 'Media and entertainment',
    text: 'Led ask possible mistress relation elegance eat likewise debating. By message or am nothing amongst chiefly address.',
  },

  {
    title: 'Automotive',
    text: 'Rental Software Development is a top-notch provider of IT tools for the Automotive industry. We provide such high-quality services as car rental app development, car sharing solutions, rideshare app development.',
  },
]

const Features = () => {
  return (
    <div className='omit__features section__padding' id='solutions'>
      <div className='omit__features-heading'>
        <h1 className='gradient__text'>
          We offer the most popular set of technologies to build cutting-edge
          solutions for your business
        </h1>
        <p>Request Our Pricing To Get Started</p>
      </div>
      <div className='omit__features-container'>
        {featuresData.map((item, index) => (
          <Feature
            key={item.title + index}
            title={item.title}
            text={item.text}
          />
        ))}
      </div>
    </div>
  )
}

export default Features
